import home from "./en-US/home";
import nav from "./en-US/nav";

const messages_en = {
    "app.title": "Handsome Boilerplate",
    "app.subtitle": "Let's Start!",
    "app.language": "Language",
    "app.OK": "OK",
    "app.Return": "Return",
    "app.selectLang": "Set Language",
    ...home,
    ...nav,
};

export default messages_en;